/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Entity, EntityData, EntityFieldKey } from '@typescript-kit/data';
import { CountryCode } from '../../shared/model/country-code.model';

export class PublicHolidayFieldKey extends EntityFieldKey {
  static readonly COUNTRY_CODE = 'countryCode';
  static readonly DATE = 'date';
  static readonly NAME = 'name';
}

export interface PublicHolidayData extends EntityData {
  countryCode?: CountryCode; //
  date?: string;
  name?: string;
}

export class PublicHoliday extends Entity implements PublicHolidayData {
  readonly countryCode: CountryCode;
  readonly date: string;
  readonly name: string;

  constructor(data: PublicHolidayData) {
    super(data);
    this.countryCode = data.countryCode;
    this.date = data.date;
    this.name = data.name;
  }
}
